import { PayoutOrderDetails, PayoutTicketManagement, PayoutOrderChecks } from '~/features/payout';
import { PayinOrderChecks, PayinTicketManagement, PayinTraderEditor } from '~/features/payin';
import { MODALS } from '~/shared/constants/modals';
import { type ResponsiveModalsMap } from '~/shared/ui/ResponsiveModals';
import { withResponsiveModalProps } from './hoc/withResponsiveModalProps';

export const responsiveModalsMap = {
    [MODALS.PAYIN_ORDER_CHECKS]: withResponsiveModalProps(PayinOrderChecks),
    [MODALS.PAYIN_TICKET_MANAGEMENT]: withResponsiveModalProps(PayinTicketManagement),
    [MODALS.PAYOUT_TICKET_MANAGEMENT]: withResponsiveModalProps(PayoutTicketManagement),
    [MODALS.PAYIN_TRADER_EDITOR]: withResponsiveModalProps(PayinTraderEditor),
    [MODALS.PAYOUT_TRADER_ORDER]: withResponsiveModalProps(PayoutOrderDetails),
    [MODALS.PAYOUT_ORDER_CHECKS]: withResponsiveModalProps(PayoutOrderChecks),
} satisfies ResponsiveModalsMap;
